import {RouteRecordRaw} from "vue-router";
import Index from "@/modules/youth/pages/Index.vue";
import NewcomersPage from "@/modules/youth/pages/NewcomersPage.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: '/youth',
    name: 'youth.index',
    component: Index,
  },
  {
    path: '/youth/newcomers',
    name: 'youth.newcomers',
    component: NewcomersPage,
  },
];
